module.exports = __webpack_public_path__ + "media/MyAudio_8.6d991546.mp3";